export const ARROW_ON_EXPAND = 'rui-icon-arrow-up-small';
export const ARROW_ON_HIDE = 'rui-icon-arrow-down-small';
export const ARROW_ON_NEXT = 'rui-icon-arrow-right-small';
export const ARROW_ON_PREVIOUS = 'rui-icon-arrow-left-small';

export const PREMIER = 'Premier';
export const FEATURED = 'Featured';

export const MIN_ITEM_WIDTH_CAROUSEL = 15;
export const MAX_ITEM_WIDTH_CAROUSEL = 100;

export const DEFAULT_IMAGE =
    'https://www.rumah123.com/asset-core/placeholder.png';

export const DEFAULT_IMAGE_CAROUSEL = [
    {
        alt: 'Image Not Found',
        id: 'id-image-not-found',
        src: DEFAULT_IMAGE,
    },
];

export const COMMENT_ITEM_DEFAULT_NUMBER = 5;
export const COMMENT_ITEM_DEFAULT_WIDTH = 550;

export const MAXIMUM_SLICE_MULTIPLE_OPTION_ITEM = 2;
export const MAXIMUM_SLICE_MULTIPLE_MOBILE_OPTION_ITEM = 1;

export const DONE_SLIDING_INTERVAL = 1000;

export const DEFAULT_DISMISS_ALERT_DURATION = 3500;

export const FOOTER_WORDING =
    'Rumah123.com adalah situs teknologi jual beli properti terdepan di Indonesia yang telah melayani jutaan orang sejak 2007, dan kini hadir untuk membuat “Jual Beli Properti Lebih Mudah” dengan dukungan developer serta agen profesional.';
